import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { BannerPrincipalLimpiaparabrisas } from './instalacion-limpiaparabrisas/banner-principal-limpiaparabrisas';
import { PrefieresQueLoHagamosNosotros } from './instalacion-limpiaparabrisas/prefieres-que-lo-hagamos-nosotros';
import { ComoCambiarLosLimpiaparabrisas } from './instalacion-limpiaparabrisas/como-cambiar-los-limpiaparabrisas';
import { ComoSaberCuandoCambiarlos } from './instalacion-limpiaparabrisas/como-saber-cuando-cambiarlos';
import { PorQueElegirNuestroServicio } from './instalacion-limpiaparabrisas/por-que-elegir-nuestro-servicio';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-cambiar-limpiaparabrisas',
  imports: [
    MainLayout,
    FormsModule,
    CommonModule,
    RouterModule,
    MarginWrapper,
    BannerPrincipalLimpiaparabrisas,
    ComoCambiarLosLimpiaparabrisas,
    ComoSaberCuandoCambiarlos,
    PorQueElegirNuestroServicio,
    PrefieresQueLoHagamosNosotros,
  ],
  template: `
    <allas-main-layout [showPopularSections]="false" [showNewsletter]="false">
      <allas-margin-wrapper styleClass="bg-white">
        <!-- Titulo Programa de Recompensas -->
        <h1 class="text-lg xl:text-4xl my-2 xl:my-4 font-medium fs-condensed">
          LIMPIAPARABRISAS
        </h1>
        <allas-banner-principal-limpiaparabrisas />
        <allas-como-saber-cuando-cambiarlos />
        <allas-por-que-elegir-nuestro-servicio />
        <allas-como-cambiar-los-limpiaparabrisas />
        <allas-prefieres-que-lo-hagamos-nosotros />
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class CambiarLimpiaparabrisas implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  constructor() {}

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle =
      'Instalación Gratis de Limpiaparabrisas | Allas Repuestos';
    const description =
      'Servicio profesional de instalación de limpiaparabrisas gratis en Honduras. Rápido, seguro y con garantía. Envío a domicilio disponible.';
    const keywords =
      'limpiaparabrisas, instalación gratis, escobillas, parabrisas, Allas Repuestos, Honduras, envío a domicilio, garantía, calidad';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
